'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Row = function Row(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ['children', 'className']);

  return React.createElement(
    'div',
    _extends({ className: className + ' md-table-row' }, props),
    children
  );
};

exports.Row = Row;
var Header = function Header(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['children']);

  return React.createElement(
    Row,
    _extends({ className: 'md-table-header' }, props),
    children
  );
};

exports.Header = Header;
var Cell = function Cell(_ref3) {
  var children = _ref3.children,
      right = _ref3.right,
      center = _ref3.center,
      flex = _ref3.flex,
      props = _objectWithoutProperties(_ref3, ['children', 'right', 'center', 'flex']);

  return React.createElement(
    'div',
    _extends({
      className: 'md-table-cell ' + (center ? 'md-table-center' : ''),
      style: { flex: flex, textAlign: right ? 'right' : null, lineHeight: 1 }
    }, props),
    children
  );
};

exports.Cell = Cell;
var Table = exports.Table = function Table(_ref4) {
  var children = _ref4.children;
  return React.createElement(
    'div',
    { className: 'md-table', style: { flex: 1 } },
    children
  );
};


//////////////////
// WEBPACK FOOTER
// ./result-list/table.js
// module id = 217
// module chunks = 0